import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const pricingPlans = [{
  name: 'Professional',
  price: '£99',
  period: 'one-time',
  description: 'Perfect for small teams getting started',
  features: ['Up to 10 team members', 'Unlimited projects', 'Client portal access', 'Basic integrations', 'Email support'],
  link: 'https://buy.stripe.com/28EcMXduE6wJg7zbCS6c001',
  highlighted: false
}, {
  name: 'Enterprise',
  price: '£120',
  period: 'one-time',
  description: 'For larger teams with advanced needs',
  features: ['Unlimited team members', 'Unlimited projects', 'Advanced client portal', 'Premium integrations', 'Priority support', 'Custom workflows', 'Advanced analytics'],
  link: 'https://buy.stripe.com/00w00b0HS2gtaNffT86c000',
  highlighted: true
}];
export const PricingPreview = () => {
  return <section className="py-20 bg-white" data-id="element-198">
      <div className="container-custom" data-id="element-199">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-200">
          <h2 className="text-3xl font-bold text-brand-blue mb-4" data-id="element-201">
            Simple, transparent pricing
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-202">
            Choose the plan that works best for your team. One-time payment,
            lifetime access.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-203">
          {pricingPlans.map((plan, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`rounded-lg p-8 ${plan.highlighted ? 'bg-gradient-to-br from-brand-blue to-brand-teal text-white shadow-xl scale-105' : 'bg-brand-light shadow-sm'}`} data-id="element-204">
              {plan.highlighted && <div className="text-sm font-semibold mb-2 text-white" data-id="element-205">
                  MOST POPULAR
                </div>}
              <h3 className={`text-2xl font-bold mb-2 ${plan.highlighted ? 'text-white' : 'text-brand-blue'}`} data-id="element-206">
                {plan.name}
              </h3>
              <div className="mb-4" data-id="element-207">
                <span className={`text-4xl font-bold ${plan.highlighted ? 'text-white' : 'text-brand-blue'}`} data-id="element-208">
                  {plan.price}
                </span>
                <span className={`text-sm ml-2 ${plan.highlighted ? 'text-white' : 'text-gray-600'}`} data-id="element-209">
                  {plan.period}
                </span>
              </div>
              <p className={`mb-6 ${plan.highlighted ? 'text-white' : 'text-gray-600'}`} data-id="element-210">
                {plan.description}
              </p>
              <ul className="space-y-3 mb-8" data-id="element-211">
                {plan.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-212">
                    <CheckIcon className={`h-5 w-5 mr-2 flex-shrink-0 ${plan.highlighted ? 'text-white' : 'text-brand-teal'}`} data-id="element-213" />
                    <span className={`text-sm ${plan.highlighted ? 'text-white' : 'text-gray-700'}`} data-id="element-214">
                      {feature}
                    </span>
                  </li>)}
              </ul>
              <a href={plan.link} target="_blank" rel="noopener noreferrer" className={`block w-full text-center py-3 px-6 rounded-md font-medium transition-all duration-200 ${plan.highlighted ? 'bg-white text-brand-blue hover:bg-opacity-90' : 'bg-brand-teal text-white hover:bg-opacity-90'}`} data-id="element-215">
                Get started
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
};